import React, { useEffect, useState } from 'react'

import { TextField, TextArea, CheckBox, Paper } from '../ui/core';
export default function Item({ item, onSave, readOnly, hideArchive, hideNote }) {
    const [editItem, setEditItem] = useState();


    const handleChange = (ev) => {
        let tmpItem = Object.assign({}, editItem);
        tmpItem[ev.target.id] = ev.target.value || ev.target.checked;
        setEditItem(tmpItem);
    }

    const handleSave = (ev) => {
        let tmpItem = {};
        tmpItem[ev.target.id] = ev.target.value;
        tmpItem._id = editItem._id;
        onSave(tmpItem);
    }

    const handleChangeAndSave = (attribute, value) => {
        let tmpItem = Object.assign({}, editItem);
        tmpItem[attribute] = value;
        setEditItem(tmpItem);

        let tmpItemSave = {};
        tmpItemSave._id = editItem._id;
        tmpItemSave[attribute] = value;
        onSave(tmpItemSave);
    }

    const handleFileUploadToBase64 = (ev,id) => {
        let tmpItem = Object.assign({}, editItem);
        let file = ev.target.files[0];
        console.log('file', file);
        if (!file) return;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let tmpItem = {};
            //tmpItem.image = reader.result;
            tmpItem[id] = reader.result;
            tmpItem._id = item._id;
            onSave(tmpItem);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    useEffect(() => {
        setEditItem(item);
    }, [item])

    if (!item) return null;

    return (
        <div className="padding">
            <Paper className="padding">
                {editItem && <>
                    <TextField id="name" label="Naam" value={editItem.name} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextField>
                    <TextField id="address" label="Adres" value={editItem.address} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextField>
                    <TextField id="pobox" label="Postcode" value={editItem.pobox} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextField>
                    <TextField id="place" label="Plaats" value={editItem.place} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextField>
                    {!hideNote && <TextArea id="description" label="Notitie" value={editItem.description} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextArea>}
                    <br /><br />

                    <TextField id="color" label="Kleurcode huisstijl" value={editItem.color} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextField>
                    <br /><br />
                    <div className='label'>Logo (hoogte 100px)</div>
                  
                   {item.image &&  <img src={item.image } alt="Scherp" style={{ height: '60px', width: 'auto', padding: '23px' }} />}<br/>
                    <input type='file' id='logo' onChange={(ev)=>handleFileUploadToBase64(ev,'image')} accept="image/gif, image/jpeg, image/png" readOnly={readOnly}/>
                    <br /><br />
  <div className='label'>Header afbeelding voor rapportage (600 * 80px)</div>
                      {item.headerImage &&  <img src={item.headerImage } alt="Scherp header image" style={{ height: '60px', width: 'auto', padding: '23px' }} />}<br/>
                    <input type='file' id='headerImage' onChange={(ev)=>handleFileUploadToBase64(ev,'headerImage')} accept="image/gif, image/jpeg, image/png"readOnly={readOnly} />
                    <br />  <br />

  <div className='label'>Footer afbeelding voor rapportage (600 * 80px)</div>
                      {item.footerImage &&  <img src={item.footerImage } alt="Scherp" style={{ height: '60px', width: 'auto', padding: '23px' }} />}<br/>
                    <input type='file' id='footerImage' onChange={(ev)=>handleFileUploadToBase64(ev,'footerImage')} accept="image/gif, image/jpeg, image/png" readOnly={readOnly}/>
                    <br />  <br />
                    <TextArea id="templateMailRespondent" label="Template mailbericht naar waarnemer" value={editItem.templateMailRespondent} onChange={handleChange} onBlur={handleSave} readOnly={readOnly}></TextArea>
                    <div className='textFieldHelper'>Gebruik de tags [name] [url] en [qrcode] in het mailbericht om automatisch de juiste waarde in te vullen.</div>
                    <br/>

                    {!hideArchive && <><div className="label">Archiveren</div>
                        <CheckBox id="archived" label="In archief plaatsen" checked={editItem.archived || false} onChange={(ev) => { handleChangeAndSave('archived', ev.target.checked) }} readOnly={readOnly} />
                    </>}
                </>}
            </Paper>
        </div>
    )
}
